<template>
    <div>
          <main class="d-flex justify-content-center inicio-home">
            <div class="container p-5">
              <form @submit.prevent="submit">
                <div class="row d-flex justify-content-center">
                    <div class="col-md-8  bg-body rounded shadow-sm p-5">
                       <h1 class="text-center">Editar cuenta
                        bancaria</h1>
                       <br>
                       <div v-if="isLoad">
                        <div class="col-md-12">
                          <label for="firstName" class="form-label">Titular de la cuenta</label>
                          <select class="form-select" aria-label="Default select example" v-model="registerForm.TitularCuenta"> 
                              <option :value="registerForm.TitularCuenta" v-text="registerForm.TitularCuenta"></option>
                            </select>
                        </div>
                        <div class="col-md-12 m-t-2">
                          <label for="firstName" class="form-label">Ponle un alias a tu cuenta</label>
                          <input type="text" class="form-control" id="firstName" placeholder="" v-model="registerForm.NombreCuenta">
                      </div> 
                        <div class="col-md-12 m-t-2">
                          <label for="firstName" class="form-label">Banco</label>
                          <select class="form-select" aria-label="Default select example" v-model="registerForm.IdTipoBanco">
                              <option v-for="(linea,index) in selectBank" :key="index" :value="linea.Id" v-text="linea.NombreParametroValor"></option>
                            </select>  
                          </div>
                          <div class="col-md-12 m-t-2">
                              <label for="firstName" class="form-label">Tipo de cuenta</label>
                              <select class="form-select" aria-label="Default select example" v-model="registerForm.IdTipoCuenta">
                                  <option v-for="(linea,index) in selectTipoC" :key="index" :value="linea.Id" v-text="linea.NombreParametroValor"></option>
                                </select>  
                          </div>
                          <div class="col-md-12 m-t-2">
                              <label for="firstName" class="form-label">Moneda</label>
                              <select class="form-select" aria-label="Default select example" v-model="registerForm.IdTipoModena">
                                  <option v-for="(linea,index) in selectTipoMo" :key="index" :value="linea.Id" v-text="linea.NombreParametroValor"></option>
                                </select>  
                          </div>
                          <div class="col-md-12 m-t-2">
                              <label for="firstName" class="form-label">Número de cuenta</label>
                              <input type="text" class="form-control" id="firstName" v-model="registerForm.NumeroCuenta" @keypress="soloNumeros"  >
                          </div> 
                          <div class="col-md-12 m-t-2">
                              <label for="firstName" class="form-label">Número de cuenta Interbancaria</label>
                              <input type="text" class="form-control" id="firstName"  v-model="registerForm.CCI" @keypress="soloNumeros" >
                          </div> <br>

                          <button class="w-100 btn btn-lg btn btn-registro" type="submit">Guardar cambios</button>
                       </div>
                        <div  class="cargando" v-if="!isLoad"></div>
                    </div>
                </div>
              </form>
            </div>
        </main>
    </div>
</template>
<script>
  import auth from '@/services/auth'
  import helpers from '@/services/helpers'
  
    export default {
      name: "EditarPerfil",
  
      data() {
      return {
        nombreCompleto:localStorage.getItem("nombreUsuario"),
        isLoad:false,
        selectBank:[],
        selectTipoC:[],
        selectTipoMo:[],
        registerForm:{
                IdBancoCliente: '',
                TitularCuenta: localStorage.getItem("nombreUsuario"),
                NombreCuenta: '',
                IdTipoBanco: '',
                IdTipoCuenta: '',
                IdTipoModena: '',
                NumeroCuenta: '',
                CCI: ''
            },
      };
    },
  
    mounted(){
      if(this.$route.params.id) {
      auth.obtenerBancoCliente(this,this.$route.params.id).then(response => {
        this.registerForm=response;
        this.registerForm.TitularCuenta=this.registerForm.TitularCuenta.toUpperCase();
        this.isLoad=true;
        
      }).catch(error => {
            this.$router.push("/user-cuentas-usuario").catch(err => {});
        });
      }
      else{
        this.$router.push("/user-cuentas-usuario").catch(err => {});
      }
    },
    
    beforeCreate(){
      helpers.actualizarTipoCambio(this);
        auth.listParameters().then(response => {
          this.selectBank=response.ParametrosGenerales.filter(e=>e.IdParametro=="BANC");
          this.selectTipoC=response.ParametrosGenerales.filter(e=>e.IdParametro=="TICU");
          this.selectTipoMo=response.ParametrosGenerales.filter(e=>e.IdParametro=="TIMO");
          this.numeroContacto=response.ParametrosGenerales.find(e=>e.Id=="NUKA0001").ValorParametroValor;
          this.horaInicio=response.ParametrosGenerales.find(e=>e.Id=="LAND0002").ValorParametroValor;
          this.horaFin=response.ParametrosGenerales.find(e=>e.Id=="LAND0002").ValorParametroValor;
          this.mensajeAtencion=response.ParametrosGenerales.find(e=>e.Id=="MENS0001");
          this.tituloMensaje=this.mensajeAtencion.NombreParametroValor;
          this.contenidoMensaje=this.mensajeAtencion.DetalleParametroValor;
        
    });
    },
    methods:{
      async submit(e) {
        if (await auth.actualizarBancoCliente(this)){
        }
        else{
        }
      },
      soloNumeros($event){
          helpers.soloNumeros($event);
    },
    },
    };
    </script>


// WEBPACK FOOTER //
// src/components/user/EditarCuentasBancarias.vue